module.exports = __webpack_public_path__ + "media/images/result_sets/circles/3r2n6r9n-645a40d380aad36b3a556a0200094e49.svg";